<template lang="pug">
#product
  //- 商品介紹頁-區塊一
  .container.container_shrink.i_pb_4
    .row.flex-md-row-reverse.justify-content-md-between
      .col-12.col-md-auto.text-center
        img.banner(
          :style="{ backgroundImage: 'url(' + productDetail.Introduce_area01_Banner + ')' }"
        )
      .col-12.col-md.i_mt_8.i_mt_md_6
        h4 {{ productDetail.Introduce_area01_Title01 }}
        list-item.i_mt_4(
          v-for="(item, index) in productDetail.Introduce_area01_Content01",
          :key="index",
          :text="item.area01_Content01_Title",
          :img="item.area01_Content01_Image"
        )
    .row.i_mt_8.i_mt_md_6
      .col-12.col-md
        h4 {{ productDetail.Introduce_area01_Title02 }}
        list-item.i_mt_4(
          v-for="(item, index) in productDetail.Introduce_area01_Content02",
          :key="index",
          :text="item.area01_Content02_Title",
          :img="item.area01_Content02_Image"
        )
    .row.i_mt_8.i_mt_md_6
      .col-12.col-md
        h4 {{ productDetail.Introduce_area01_Title03 }}
        list-item.i_mt_4(
          v-for="(item, index) in productDetail.Introduce_area01_Content03",
          :key="index",
          :text="item.area01_Content03_Title",
          :img="item.area01_Content03_Image"
        )

  media-img.golden_line_up(:imgUrl="'golden_line_up'")

  //- 健康-商品介紹頁-區塊二 保障項目
  ensure-terms(
    v-if="productDetail.DetailType == '2'",
    :itemTitle="productDetail.Introduce_area02_ItemTitle",
    :itemList="productDetail.Introduce_area02_ItemList",
    :otherItemTitle="productDetail.Introduce_area02_OtherItemTitle",
    :otherItemList="productDetail.Introduce_area02_OtherItemList"
  )

  media-img.golden_line_up(
    :imgUrl="'golden_line_up'",
    v-if="productDetail.DetailType == '2'"
  )

  //- 商品介紹頁-區塊二 保障範圍說明
  .container-fluid.bg_light_blue.i_ptb_8
    section.container.container_shrink.feature
      .row.flex-md-row-reverse.justify-content-md-between
        .col-12.text-center
          h2.i_h2_title {{ productDetail.Introduce_area02_Title }}
          p.i_body_l {{ productDetail.Introduce_area02_SubTitle }}
      .row.text-md-center
        .col-md-4.d-flex.flex-md-column(
          v-for="item in productDetail.Introduce_area02_Content"
        )
          img.flex-shrink-0.i_mlr_auto.i_mb_sm_8(
            :src="item.area02_Content_Image"
          )
          .content.i_ml_sm_6
            h5.i_mt_4.i_mt_md_5.i_mt_sm_0 {{ item.area02_Content_Title }}
            p.i_body_l.i_mt_4.i_mt_md_3.i_mt_sm_2 {{ item.area02_Content_SubTitle }}

  media-img.golden_line_up(:imgUrl="'golden_line_up'")

  //- 商品介紹頁-區塊三 服務特色清單
  section.container-fluid.bg_white.services
    .container.i_ptb_8
      .row
        .col-12.text-center
          h2.i_h2_title {{ productDetail.Introduce_area03_Title }}
          h5.i_body_l {{ productDetail.Introduce_area03_SubTitle }}
      .row.i_mt_6.d-none.d-md-flex
        .col-4.align-items-center(
          v-for="(service, index) in productDetail.Introduce_area03_Content",
          :key="index"
        )
          three-grid-item.i_mt_7(
            :title="service.area03_Content_Title",
            :subtitle="service.area03_Content_SubTitle",
            :img="service.area03_Content_icon"
          )
      .row.i_mt_6.d-md-none.mobile
        .col-12.i_p_0
          swiper.swiper-container(:options="swiperOption", ref="mySwiper")
            swiper-slide.swiper-slide.d-flex.flex-column.align-items-center(
              v-for="(service, index) in productDetail.Introduce_area03_Content",
              :key="index"
            )
              three-grid-item(
                :title="service.area03_Content_Title",
                :subtitle="service.area03_Content_SubTitle",
                :img="service.area03_Content_icon"
              )

          svg-icon.swiper-prev.d-md-none(
            iconClass="arrow_left_mobile",
            className="icon",
            @click="prevClick"
          )

          svg-icon.swiper-next.d-md-none(
            iconClass="arrow_right_mobile",
            className="icon",
            @click="nextClick"
          )
      .row.i_mt_8
        .see_more_btn.sm.btn_yellow(@click="toDifferent") 看更多

  media-img.golden_line_up.i_mt_8(:imgUrl="'golden_line_up'")

  //- 商品介紹頁-區塊四 組合方案
  .container-fluid.bg_light_blue
    solution(
      :title="productDetail.Introduce_area04_Title",
      :subTitle="productDetail.Introduce_area04_SubTitle",
      :content="productDetail.Introduce_area04_Content"
    )

  //- 一般-商品介紹頁-區塊五 附加商品
  //- additional-item(
  //-   v-if="productDetail.DetailType == '1'",
  //-   :additionalList="productDetail.Introduce_area05_AddProduct",
  //-   :isBusiness="false"
  //- )
  additional-item(
    v-if="false",
    :additionalList="productDetail.Introduce_area05_AddProduct",
    :isBusiness="false"
  )
  media-img.golden_line_up.i_mt_8(:imgUrl="'golden_line_up'")

  //- 商品介紹頁-區塊六 常見問答
  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_2 聚焦問題 解答疑惑
    p.i_body_l.text-center(v-if="false") 也歡迎至「
      span
        router-link(
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }",
          style="cursor: pointer; color: #009ce5"
        ) 聯絡我們
      | 」留下問題，將有專人主動聯繫回覆您
    .row
      .col-6.col-md-3.i_mt_8.i_mt_md_4(v-for="question in questions")
        question(:question="question")
    .row
      router-link.see_more_btn.sm.btn_blue_ci.text-center.i_mtb_10(
        tag="a",
        :to="{ name: 'CustomerServiceFAQ' }"
      ) 看更多
</template>

<script>
import { getFAQDetail } from "@/json/FAQ";
import Listitem from "@/components/product/Intro/Listitem";
import EnsureTerms from "@/components/product/Intro/EnsureTerms";
import MediaImg from "@/components/common/MediaImg";
import ThreeGridItem from "@/components/common/ThreeGridItem";
import Solution from "@/components/product/Intro/NormalIntro/Solution";
import AdditionalItem from "@/components/product/Intro/AdditionalItem";
import Question from "@/components/common/Question";

export default {
  name: "NormalIntro",
  components: {
    "list-item": Listitem,
    "ensure-terms": EnsureTerms,
    "media-img": MediaImg,
    "three-grid-item": ThreeGridItem,
    solution: Solution,
    "additional-item": AdditionalItem,
    question: Question,
  },
  props: {
    productDetail: Object,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 3,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      questions: [],
      FAQDetail: [],
      firstFlag: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    productDetail() {
      if (this.firstFlag) {
        this.getProductQuestion();
      }
    },
  },
  created() {
    this.getFAQDetail();
  },
  methods: {
    getFAQDetail() {
      getFAQDetail().then((response) => {
        this.FAQDetail = response.data.FAQDeatilList;
        this.getProductQuestion();
      });
    },
    getProductQuestion() {
      this.questions = [];
      if (
        this.productDetail.Introduce_area06_FAQ01ID &&
        this.productDetail.Introduce_area06_FAQ01ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ01ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.productDetail.Introduce_area06_FAQ02ID &&
        this.productDetail.Introduce_area06_FAQ02ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ02ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.productDetail.Introduce_area06_FAQ03ID &&
        this.productDetail.Introduce_area06_FAQ03ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ03ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.productDetail.Introduce_area06_FAQ04ID &&
        this.productDetail.Introduce_area06_FAQ04ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ04ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }
      this.firstFlag = true;
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    toDifferent() {
      this.$router.push({
        name: "DifferenceService",
        params: {
          id: this.productDetail.Introduce_area03_ID,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/intro/intro";
</style>
